import React, { Component } from "react";
import "./QueryResults.scss";
import PostContainer from "../../../../MainContent/RawData/Post/PostContainer";
var Masonry = require("react-masonry-component");
import { connect } from "react-redux";
import Dimmer from "semantic-ui-react/dist/es/modules/Dimmer";
import Loader from "semantic-ui-react/dist/es/elements/Loader";

class QueryResults extends Component {
    constructor(props) {
        super(props);
        this.masonryOptions = {
            hiddenStyle: {
                transform: "translateY(100px)",
                opacity: 0,
            },
            visibleStyle: {
                transform: "translateY(0px)",
                opacity: 1,
            },
        };
    }

    getChildElements() {
        let rawData = this.props.rawData || [];
        // if (this.props.offset == this.totalPages && this.total % 50 !== 0) {
        //     rawData = rawData.slice(0, this.total % 50);
        // }
        return rawData.map((el, ind) => {
            return (
                <PostContainer
                    key={el._id}
                    data={el}
                    appliedFilter={null}
                    index={ind}
                    company={this.props.company}
                    setSentiment={(sentiment) => this.props.setSentiment(el._index + ":" + el._id, sentiment, this.props.company, rawData)}
                    showPostEmailPopup={() => this.postEmailModalShowSet(true, el)}
                    showMarkIrrPopup={() => this.markIrrModalShowSet(true, el)}
                    showTagClientPopup={() => this.tagClientModalShowSet(true, el)}
                    showAddToCollectionPopup={() => this.addToCollectionModalSet(true, el)}
                    // customQuery={this.props.appliedFilter.filter_data.filterKeyword}
                    showPostComments={(info) => this.showPostComments(info)}
                    showPostReplys={(info) => this.showPostReplys(info)}
                    showTempoTractionGraph={(data) => this.tempoTractionModalShowSet(true, data)}
                    showPostInfo={(id, platformName) => this.showPostInfo(id, platformName)}
                    selectable={this.props.showBulkOptions}
                    toggleSelected={(id) => this.props.toggleSelected(id)}
                    toggleToDeselect={(id) => this.props.toggleToDeselect(id)}
                    selected={this.props.selectedPosts ? this.props.selectedPosts.indexOf(el._index + ":" + el._id) > -1 : false}
                    deselected={this.props.deselectedPosts ? this.props.deselectedPosts.indexOf(el._index + ":" + el._id) > -1 : false}
                    deselectedPostsCount={this.props.deselectedPosts ? this.props.deselectedPosts.length : 0}
                    selectAll={this.props.selectAll}
                    LNOfflineModalShow={(data) => this.LNOfflineModalShow(true, data)}
                    // listView={false}
                />
            );
        });
    }
    render() {
        return (
            <div className="queryResults">
                {this.total !== 0 && (
                    <Masonry
                        className={"rawdata-cards-container"}
                        style={{ marginTop: "5px" }}
                        elementType={"section"}
                        disableImagesLoaded={false} // default false
                        options={this.masonryOptions} // default {}
                        updateOnEachImageLoad={false} // default false and works only if disableImagesLoaded is false
                    >
                        {this.getChildElements()}
                    </Masonry>
                )}
                {this.props.queryResultsLoading && (
                    <div className="list-loading">
                        <Dimmer inverted active>
                            <Loader size="big skiptranslate">Loading</Loader>
                        </Dimmer>
                    </div>
                )}
            </div>
        );
    }
}
const mapStateToProps = (state) => {
    return {
        // queryResultsLoading: state.queryBuilderReducer.queryResultsLoading,
        // queryResults: state.queryBuilderReducer.queryResults,
        // appliedFilter: state.globalReducer.appliedFilter,
        // filters: state.globalReducer.filters,
        company: state.globalReducer.company,
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        searchQueryResults: (data) => dispatch(searchQueryResults(data)),
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(QueryResults);
